import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import { accountByCodeSelector, combinedSelector, accountsSelector } from '../selectors/selectors'
import { getAccountOptions, SelectorFunction, FetchAccountsProps } from './getAccountOptions'

export const useFetchAccounts = <TData, Params extends FetchAccountsProps = FetchAccountsProps>(
  selectFunction?: SelectorFunction<TData, Params>,
  params?: Params
): UseQueryResult<TData> => {
  const { companyId, lng } = useContextParameters()

  return useQuery(getAccountOptions(companyId, lng, selectFunction, params))
}

export const useAccount = (code?: number) => {
  return useFetchAccounts(accountByCodeSelector, { code })
}

export const useAccounts = () => {
  return useFetchAccounts(accountsSelector)
}

export const useAccountsArgumentOptions = () => {
  return useFetchAccounts(combinedSelector)
}
